import type { AuthRealm } from '~/shared-kernel/domain/auth'

export interface RealmCookieNames {
  accessToken: string
  refreshToken: string
  sessionToken: string
  passwordChangeToken: string
}

export function getRealmCookieNames(realm: AuthRealm): RealmCookieNames {
  return {
    accessToken: `tq_${realm}_access`,
    refreshToken: `tq_${realm}_refresh`,
    sessionToken: `tq_${realm}_session`,
    passwordChangeToken: `tq_${realm}_password_change`
  }
}
